import React from 'react';
import classNames from 'classnames';

/**
 * @param {React.PropsWithChildren<{
 *   severity?: 'success' | 'warning' | 'error' | 'info' | 'secondary';
 *   icon?: string;
 * }>} props
 */
export const InfoEntry = (props) => {
  const severityClassNameMap = {
    'success': 'text-green-500',
    'warning': 'text-orange-500',
    'error': 'text-red-500',
    'info': 'text-blue-500',
    'secondary': 'text-gray-400',
  };

  return (
    <div className={classNames("flex align-items-start gap-1", severityClassNameMap[props.severity])}>
      <i className={props.icon ?? 'pi pi-info-circle'} />
      <span className="text-sm">{props.children}</span>
    </div>
  );
};
